import { useState, useEffect } from "react";
import { Progress } from "antd";
import "./CustomProgress.css";
import { primaryColor } from "colors-config";

const messages = [
  "Gathering your scans...",
  "Mapping the perfect treatment plan for you...",
  "Almost ready to reveal your new smile!",
];

const CustomProgress = ({ percent }) => {
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setMessageIndex((prevIndex) => (prevIndex + 1) % messages.length);
    }, 5000); // Change message every 5 seconds

    return () => clearInterval(interval); // Cleanup interval on unmount
  }, []);

  return (
    <div className="custom-progress-container">
      <Progress
        size={250}
        type="circle"
        percent={percent}
        strokeColor={primaryColor}
        className="custom-progress"
      />
      <p>{messages[messageIndex]}</p>
    </div>
  );
};

export default CustomProgress;
